import { Link } from 'react-router-dom'
import { SiteContentLayout } from '../components/SiteContentLayout'
import { CONTACT_PAGE } from '../constants/contact-page'

export function ContactPage() {
  return (
    <SiteContentLayout
      eyebrow={CONTACT_PAGE.eyebrow}
      title={CONTACT_PAGE.title}
      lead={CONTACT_PAGE.lead}
    >
      <div className="content-page__split">
        <section className="content-page__card">
          <h2>{CONTACT_PAGE.officeTitle}</h2>
          <p>{CONTACT_PAGE.companyName}</p>
          <p>{CONTACT_PAGE.officeAddress}</p>
          <p>
            {CONTACT_PAGE.gstinLabel}: {CONTACT_PAGE.gstin}
          </p>
        </section>
        <section className="content-page__card">
          <ul className="content-page__channels">
            {CONTACT_PAGE.channels.map((channel) => (
              <li key={channel.label}>
                <span>{channel.label}</span>
                <a href={channel.href}>{channel.value}</a>
              </li>
            ))}
          </ul>
        </section>
      </div>

      <section className="content-page__section">
        <h2>{CONTACT_PAGE.linksTitle}</h2>
        <ul className="content-page__cta-row">
          {CONTACT_PAGE.links.map((link) => (
            <li key={link.to}>
              <Link className="content-page__cta content-page__cta--ghost" to={link.to}>
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </SiteContentLayout>
  )
}
